<template>
  <article class="">
    <header>
				<span class="date">Weltweit</span>
				<h2>Weitere Herzensprojekte</h2>
			</header>
    <RTProjectCover class="logo-cover m-auto" :stream="{cover:'/images/sofareisen_logo_all.png'}"/>
    <p class="mt-2 text-center">In Kürze folgen weitere Projekte, die dringend Unterstützung benötigen</p>
  </article>
</template>

<script>

import {helper} from '@/mixins/helper.js'
import {projectBase} from '@/mixins/projectBase.js'
import RTProjectCover from '@/components/RTProjectCover.vue'
export default {
  name: 'RTProjectEmptyDefault',
  mixins:[helper,projectBase],
  props:{
  },
  components: {
    RTProjectCover
  },
  data: function() {
    return {
    };
  },
  watch:{
  },
  computed:{

  },
  methods:{
  },
  /*
  beforeRouteEnter: (to,from,next) => {
		next(() => {
       setTimeout(()=>{
				window.scrollTo(0, 0);
			},300);
		});
  },
  */
  created() {
  },
  destroyed() {
  },
};
</script>

<style scoped type='text/css'>
</style>